import { useEffect } from 'react';
import { useSafes, useSafesBalances, useTokenPrices } from 'store';
import { IMultiSignWallet } from 'types';

import { useGetSafeBalance } from './useGetSafeBalance';

export const useRefreshCurrentSafeBalance = (safe: IMultiSignWallet) => {
  const getSafeBalance = useGetSafeBalance();
  const { safes } = useSafes();
  const { safesBalances, setSafesBalances } = useSafesBalances();
  const { tokenPrices: tokenPriceRecord } = useTokenPrices();

  const getSafeAndSubAccountsBalances = () => {
    if (!Object.keys(tokenPriceRecord).length || !safe?.address) return;

    const safeSubAccounts = safes.filter((x) => x.parrentId === safe._id);
    Promise.all(([safe, ...safeSubAccounts] as IMultiSignWallet[]).map(getSafeBalance)).then(
      (balances) => {
        const newSafeBalances: Record<string, number> = { ...safesBalances };
        safes.forEach((s, i) => {
          if (balances[i] !== undefined) {
            newSafeBalances[s.address] = balances[i];
          }
        });
        setSafesBalances(newSafeBalances);
      }
    );
  };

  useEffect(() => {
    getSafeAndSubAccountsBalances();
  }, [safe]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      getSafeAndSubAccountsBalances();
    }, 60_000);

    return () => clearInterval(intervalId);
  }, [safe, tokenPriceRecord]);
};
